import { Text } from '@harperai/materialize-design-system';
import './style/Loader.css';
import React, { useState, useEffect } from 'react';

const Loader = ({ loading, absolute = true, small = false, showLoadingText, loadingTextOptions }) => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    useEffect(() => {
        if (showLoadingText) {
            const interval = setInterval(() => {
                setCurrentTextIndex((currentTextIndex + 1) % loadingTextOptions.length);
            }, 4000);
            return () => clearInterval(interval);
        }
    }, [currentTextIndex, showLoadingText, loadingTextOptions]);

    return (
        <div id="keystone-loader" className={`${absolute ? 'loader-absolute' : ''} ${small ? "loader-small" : ""} ${loading ? 'shown' : 'hidden'} center-text`}>
            <div className="keystone-loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            {showLoadingText && <div id="loader-label" className={!small ? "" : "pad-s"}>
                <Text header={5} size={!small ? "h6" : "paragraph"} variant={!small ? "primary" : "secondary"} bold={true}>{loadingTextOptions[currentTextIndex]}</Text>
            </div>}
        </div>
    );
};

export default React.memo(Loader);